import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../components/SeoHead';
import MainBanner from '../../components/MainBanner';
import LatestNews from '../../components/LatestNews';
import AllSectors from '../../components/AllSectors';
import AllSolutions from '../../components/AllSolutions';
import HorizontalAnchorLinks from '../../components/HorizontalAnchorLinks';

export default function BusinessSolutionsPage({
    global,
    all_news,
    all_sectors,
    all_solutions
}) {
    return (
        <>
            <SeoHead
                page_name={`Business Solutions | Staffing Agency | US and Canada Staffing | Bartech Staffing`}
                canonical_link={`business-solutions`}
            />
            <MainBanner
                global={global}
                pathPrefix={`business_solutions_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Business Solutions</h1>
                    </>
                }
                subtitle={
                    <p>Bartech’s Executive Search focuses on finding new leaders within the Engineering, Technical, and Professional spheres that drive the business to success from the top. We have helped hundreds of candidates find their place at some of the world’s leading organizations. Our experience has taught us the characteristics and skills it takes to drive success at a senior level for a range of different businesses. We’re agile to market shifts, aligned to customer needs and embedded in executive circles – giving you access to vital skills at the highest level. </p>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
                imageALT2={`Overlay Main Banner`}
                displayImage1={false}
            />
            <AllSectors
                global={global}
                pathPrefix={`business_solutions_page.all_sectors`}
                customClass={`py-5 grayGradientBg`}
                content={
                    <>
                        <h2>Our Recruitment Expertise</h2>
                    </>
                }
                post={all_sectors}
            />
            <HorizontalAnchorLinks
                global={global}
                pathPrefix={`business_solutions_page.horizontal_anchor_links`}
                customClass={``}
                post={all_solutions}
            />
            <AllSolutions
                global={global}
                pathPrefix={`business_solutions_page.all_solutions`}
                customClass={`py-5`}
                post={all_solutions}
                buttonTitle={`Learn More`}
            />
            <LatestNews
                global={global}
                pathPrefix={`business_solutions_page.latest_news`}
                customClass={`py-5 blueGradientBg top-rounded-radius`}
                post={all_news}
                content={
                    <>
                        <h2>The Lorien Pulse: Latest News, Events, and Insights</h2>
                        <p>Our tech expertise and partner-led approach allows us to deliver highly successful results for our clients so they can attract and retain unique talent for their business. Explore our latest collection of case studies, news, events, and insights</p>
                    </>
                }
                buttonLink={`/insights/`}
                buttonTitle={`View All Insights`}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const news = await Collection('news');
    const sectors = (await Collection('sectors'));
    const solutions = await Collection('solutions');

    const all_solutions = solutions.orderBy('order').getItems();
    const all_sectors = sectors.orderBy('order').getItems();
    const all_news = news.orderBy('date').getItems().slice(0, 8);
    return {
        props: {
            global,
            all_news,
            all_sectors,
            all_solutions
        }
    };
}
